module.exports = __webpack_public_path__ + "static/media/Target.97e1ebd4.png";